import React from 'react';
import axios from 'axios';
import { Button, Form, Input, Checkbox } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class CreateCourse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ects: '',
            lectureNumber: '',
            exerciseNumber: '',
            seminarNumber: '',
            tutorialNumber: 0,
            code: '',
            mandatory: false,
            fromOtherStudyProgram: false,
            prerequisiteCourse: false,

            ectsErr: false,
            codeErr: false,
            lectureNumberErr: false,
            exerciseNumberErr: false,

        };
        this.addCourse = this.addCourse.bind(this);
    }

    addCourse(
        ects,
        lectureNumber,
        exerciseNumber,
        seminarNumber,
        tutorialNumber,
        mandatory,
        fromOtherStudyProgram,
        prerequisiteCourse,
        code
    ) {
        let courseBasicId = this.props.id;

        let studyProgramId = this.props.newSPId;

        let courseObj = {
            studyProgramId,
            code,
            ects,
            lectureNumber,
            exerciseNumber,
            seminarNumber,
            tutorialNumber,
            mandatory,
            fromOtherStudyProgram,
            prerequisiteCourse,
            courseBasicId
        };

        let courses = [courseObj];
        let studyProgramSemesterId = this.props.semesterId;

        let createSemObj = { courses, studyProgramSemesterId };

        if (!ects || !lectureNumber || !exerciseNumber || !code) {
            toast('Niste unijeli sva obavezna polja!');
            if (!ects) { this.setState({ ectsErr: true }); } else { this.setState({ ectsErr: false }); }
            if (!code) { this.setState({ codeErr: true }); } else { this.setState({ codeErr: false }); }
            if (!lectureNumber) { this.setState({ lectureNumberErr: true }); } else { this.setState({ lectureNumberErr: false }); }
            if (!exerciseNumber) { this.setState({ exerciseNumberErr: true }); } else { this.setState({ exerciseNumberErr: false }); }
        } else {
            axios.post('study-programs/semesters/courses/', { ...createSemObj })
                .then(res => {
                    toast('Uspješno ste dodali predmet u semestar.');
                    this.props.addCourse(courseBasicId);
                })
                .catch(err => {
                    const msg = (err && err.response && err.response.data) ? err.response.data : '';
                    if (typeof msg === 'string' && msg.includes('You must enter the course through the course section.')) {
                        toast('Predmet se nalazi u listi predmeta za ovu implementaciju, te ga je potrebno tu i unijeti!');
                    } else if (typeof msg === 'string' && msg.includes('Course already exists in semester.')) {
                        toast('Predmet se već nalazi u semestru!');
                    } else if (typeof msg === 'string' && msg.includes('Course must belong to at least one semester.')) {
                        toast('Predmet se nalazi u listi predmeta, ali mu nije dodijeljen semestar!');
                    } else {
                        toast('Došlo je do greške! Dodavanje predmeta u semestar nije uspjelo.');
                    }
                    console.log('error log');
                    console.log(err);
                })
                .finally(console.log('Izvršeno dodavanje'));
        }
    }

    render() {
        return (
            <div>

                <h3>{this.props.name}</h3>
                <Form noValidate>
                    <Form.Group widths="equal">
                        <Form.Field
                            required
                            error={this.state.ectsErr}
                            control={Input}
                            label="Broj ECTS bodova"
                            type="number"
                            value={this.state.ects}
                            onChange={(e) => this.setState({ ects: e.target.value })}
                            name="ects"
                            placeholder="Unesite broj ects bodova"
                        />
                        <Form.Field
                            required
                            error={this.state.codeErr}
                            control={Input}
                            label="Šifra"
                            value={this.state.code}
                            onChange={(e) => this.setState({ code: e.target.value })}
                            name="code"
                            placeholder="Unesite šifru"
                        />
                        <Form.Field />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            required
                            error={this.state.lectureNumberErr}
                            control={Input}
                            label="Predavanja (sati)"
                            type="number"
                            value={this.state.lectureNumber}
                            onChange={(e) => this.setState({ lectureNumber: e.target.value })}
                            name="lectureNumber"
                            placeholder="Unesite broj predavanja"
                        />
                        <Form.Field
                            required
                            error={this.state.exerciseNumberErr}
                            control={Input}
                            label="Vježbe (sati)"
                            type="number"
                            value={this.state.exerciseNumber}
                            onChange={(e) => this.setState({ exerciseNumber: e.target.value })}
                            name="exerciseNumber"
                            placeholder="Unesite broj vježbi"
                        />
                        <Form.Field
                            control={Input}
                            label="Seminari"
                            type="number"
                            value={this.state.seminarNumber}
                            onChange={(e) => this.setState({ seminarNumber: e.target.value })}
                            name="seminarNumber"
                            placeholder="Unesite seminare"
                        />
                        <Form.Field
                            control={Input}
                            label="Tutorijali (sati)"
                            type="number"
                            value={this.state.tutorialNumber}
                            onChange={(e) => this.setState({ tutorialNumber: e.target.value })}
                            name="tutorialNumber"
                            placeholder="Unesite broj tutorijala"
                        />

                    </Form.Group>
                    <Form.Group>
                        <Form.Field>
                            <label>Je li predmet izborni?</label>
                            <Checkbox
                                disabled={this.state.fromOtherStudyProgram}
                                defaultChecked
                                label=""
                                value={this.state.mandatory}
                                onChange={(e) => this.setState({ mandatory: !this.state.mandatory })}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Je li predmet uslovni?</label>
                            <Checkbox
                                disabled={this.state.fromOtherStudyProgram}
                                label=""
                                value={this.state.prerequisiteCourse}
                                onChange={(e) => this.setState({ prerequisiteCourse: !this.state.prerequisiteCourse, fromOtherStudyProgram: false })}
                            />
                        </Form.Field>
                        <Form.Field width={5}>
                            <label>Je li predmet sa drugog studijskog programa ili NPP-a?</label>
                            <Checkbox
                                disabled={this.state.prerequisiteCourse}
                                label=""
                                value={this.state.fromOtherStudyProgram}
                                onChange={(e) => this.setState({ fromOtherStudyProgram: !this.state.fromOtherStudyProgram, mandatory: false, prerequisiteCourse: false })}
                            />
                        </Form.Field>
                    </Form.Group>
                    <Button
                        color="blue"
                        size="small"
                        onClick={() => this.addCourse(
                            this.state.ects,
                            this.state.lectureNumber,
                            this.state.exerciseNumber,
                            this.state.seminarNumber,
                            this.state.tutorialNumber,
                            this.state.mandatory,
                            this.state.fromOtherStudyProgram,
                            this.state.prerequisiteCourse,
                            this.state.code
                        )}

                    >  Dodaj u semestar
                    </Button>
                    <Button
                        color="blue"
                        size="small"
                        basic="true"
                        onClick={() => this.props.openAddCourseMode(1)}
                    >  Odustani
                    </Button>

                </Form>
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}

export default CreateCourse;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/CreateCourse.js